import { useRef } from 'react';
import { colors, Typography } from '@sweep-io/sweep-design';
import { Box } from '@mui/material';
import { renderToStaticMarkup } from 'react-dom/server';
import { getIndentation } from './utils';
import unescape from 'lodash/unescape';

interface ListWithScrollProps {
  sourceCode: string;
}

export const ListWithScroll = ({ sourceCode }: ListWithScrollProps) => {
  const parentRef = useRef<HTMLDivElement>();
  const lines = renderToStaticMarkup(sourceCode)?.trim().split('\n');

  return (
    <Box component="pre" pl={2} pr={2} height="100%" overflow="auto" ref={parentRef}>
      {lines?.map((line, index) => {
        // Calculate the indentation for each line
        const indentation = getIndentation(line);
        const unescapedLine = unescape(line).trim();

        return (
          <Box
            key={index}
            sx={{
              pl: `${indentation * 4}px`, // Multiply by 4px for each space
              minWidth: 0,
              '& mark': {
                background: colors.lemon[100],
                fontWeight: 400,
              },
              '& mark.search-highlight-current': {
                background: colors.spark,
                fontWeight: 400,
              },
            }}
          >
            <Typography
              variant="body"
              whiteSpace="break-spaces"
              wordBreak="break-word"
              color={colors.grey[800]}
            >
              {unescapedLine}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
